import axios from "axios";
axios.defaults.withCredentials = true;
// 创建axios实例
const service = axios.create({
  // baseURL: process.env.VUE_APP_BASE_API,
  // baseURL: window.url,
  baseURL: '',
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 300000, // request timeout
  // headers: {
  //   Authorization: localStorage.getItem('token') ? 'Bearer ' + localStorage.getItem('token') : ''
  // }
});

// request拦截器
service.interceptors.request.use(
  config => {
    config.headers.Authorization = localStorage.getItem('token') ? 'Bearer ' + localStorage.getItem('token') : ''
    return config;
  },
  error => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error);
  }
);

service.interceptors.response.use(
  response => {
    if (response.status === 200) {
      if (response.data.code == 0 || response.data.code == 401) {
        const res = response.data;
        return res;
      } else {
        window.vue_this.$message({
          message: response.data.message,
          type: "info",
          duration: 2000
        });
        window.vue_this.$store.dispatch("store/setDrawerTable", true);
        window.vue_this.$store.dispatch("store/setLoading", false);
      }
    } else {
      return Promise.reject(response.statusText);
    }
  },
  error => {
    if ((error + '').indexOf('Error: timeout' > -1)) {
      window.vue_this.$message({
        message: '请求数据超时，请重试或联系售后人员',
        type: "info",
        duration: 2000
      });
    }
    console.log(error);
    return Promise.reject(error);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/util/request.js